/* eslint-disable implicit-arrow-linebreak */
/* global G */
import settings from '@tenant/settings'
import _getDefaultRoute from 'platform/adapter/router/effect/getDefaultRoute'

const staticItem = {
  route: {
    module: 'static',
    action: 'text',
  },
}

/**
 * Reset App History Effect
 *
 * Empties the navigation stack if the current module and action are defined as a navigation or menu
 * routes.
 *
 * @param {Gaia.Web.Application} app
 * @returns {function(...[*]): *[]}
 */
const resetAppHistory = app => (...args) => {
  const defaultRoute = _getDefaultRoute(app)
  const { navigation, menu, unregistered } = app[G.CONFIGURATION].defaults
  const { staticActions } = settings
  const sessionState = app[G.SESSION][G.STATE]
  // obtaining currently set module and action
  const currentModule = sessionState[G.MODULE]?.[G.CONFIGURATION]?.module
  const currentAction = sessionState[G.ACTION]

  // checking whether the current route belongs to the unregistered module (guest)
  const isLogin = unregistered.module === currentModule
    && unregistered.action === currentAction

  // checking whether the current route is the default one (user's home)
  const isDefaultRoute = defaultRoute.module === currentModule
    && defaultRoute.action === currentAction

  // checking whether current module and action are defined in navigation/menu elements
  const navigationItems = [...navigation, ...menu, ...staticActions || [], staticItem]
  const isNavigation = navigationItems.some(({ route = {} }) =>
    route.module === currentModule && route.action === currentAction)

  const shouldReset = isNavigation || isLogin || isDefaultRoute

  // clearing history stack if current module and action are defined in navigation/menu
  sessionState[G.PREV] = shouldReset ? [] : sessionState[G.PREV]

  return args
}

export default resetAppHistory
